import { createStore, compose, applyMiddleware} from 'redux';
import createSagaMiddleware from 'redux-saga'

import { loadUser } from 'redux-oidc';
import reducer from './reducer';
import userManager from '../auth/userManager';
import { watchAuth } from './sagas/auth';
import { watchAccountVerification } from './sagas/accountVerification';
import { watchGeo } from './sagas/geo';
import { watchPlans } from './sagas/plans';
import { watchSubscription } from './sagas/subscription';
import { watchBillingInformation } from './sagas/billingInformation';
import { watchSettings } from './sagas/settings';
import { watchPaymentMethods } from './sagas/paymentMethods';
import { watchInvoices } from './sagas/invoices';

let composeEnhancers = compose;

if(process.env.NODE_ENV !== 'production') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const sagaMiddleware = createSagaMiddleware();

const enhancers = composeEnhancers(applyMiddleware(sagaMiddleware));

const store = createStore(reducer, enhancers);

sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchAccountVerification);
sagaMiddleware.run(watchGeo);
sagaMiddleware.run(watchPlans);
sagaMiddleware.run(watchSubscription);
sagaMiddleware.run(watchBillingInformation);
sagaMiddleware.run(watchSettings);
sagaMiddleware.run(watchPaymentMethods);
sagaMiddleware.run(watchInvoices);


loadUser(store, userManager);

export default store;